module.exports = __webpack_public_path__ + "static/media/sample-row.c4cf6c8a.png";